var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('url-sync',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var updateQuery = ref.updateQuery;
return [_c('registry-search',{attrs:{"filter":_vm.filter,"sorting":_vm.sorting,"tokens":[],"sortable-fields":_vm.sortableFields},on:{"sorting:changed":_vm.updateSorting,"filter:changed":_vm.setFilter,"filter:submit":function($event){return _vm.$emit('update')},"query:changed":updateQuery}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }